import CircularProgress from '@mui/material/CircularProgress';
import {lazy, Suspense} from 'react';

const LazyReportHistoryListWithShare = lazy(() => import('./ReportHistoryListWithShare'));

const Fallback = (
  <div className="ReportHistoryListWithShare no-reports">
    <CircularProgress color="primary"/>
  </div>
);

const ReportHistoryListWithShare = props => (
  <Suspense fallback={Fallback}>
    <LazyReportHistoryListWithShare {...props} />
  </Suspense>
);

export default ReportHistoryListWithShare;
